import { z } from "zod";
import { useViewContextStore } from "../store/view-context-store";
import { useClientTool } from "./use-client-tool";

/**
 * Register getDetailedViewContext tool
 *
 * This tool allows the AI to retrieve detailed context about the current view.
 * It returns the long context from all registered view contexts.
 */
export function useViewContextTool() {
  const getAllLongContexts = useViewContextStore((state) => state.getAllLongContexts);

  useClientTool({
    toolName: "getDetailedViewContext",
    description:
      "Get detailed information about what the user is currently viewing. Use this when the user asks about current screen data (reports, appointments, calendar, etc.). Returns comprehensive details about visible data, metrics, and status.",
    parameters: z.object({}), // No parameters needed
    execute: async () => {
      const longContext = getAllLongContexts();
      return {
        context: longContext,
      };
    },
  });
}
